export const changeSelectedDefaultMarket = (activeMarket) => ({
    type: 'CHANGE_SET_ACTIVE_MARKET',activeMarket
});
